<template>
    <div class="position-absolute w-100 min-height-300 top-0 ">
        <div class="mask bg-segment-primary-color"></div>
    </div>
    <div id="sidenav-main"
        class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-4 py-2"
        :class="` ${sidebarType} ${false ? 'fixed-end me-3 rotate-caret' : 'fixed-start ms-3'} ${layout === 'landing' ? 'bg-transparent shadow-none' : ''}`"
        style="margin-top: 10px !important;">
        <div class="float-end me-2" @click.prevent="navbarMinimize">
            <button v-if="showCloseButtonLgScreen()" class="p-0 btn btn-link text-dark fixed-plugin-close-button">
                <i class="fa fa-close"></i>
            </button>
        </div>
        <div class="sidenav-header d-flex justify-content-center align-items-center">
            <a class="mt-3" href="#" @click="toggleComponent('PrincipalCard')">
                <img :src="`/brasal/${segment}.png`" :class="segment" alt="Logo Brasal" />
            </a>
        </div>
        <div class="d-flex justify-content-center mt-4 custom-bg"
            :style="{ backgroundColor: contractData && contractData.cor_primaria ? contractData.cor_primaria : '#bfbebb' }">
            <div class="">
                <div class="d-flex justify-content-center">
                    <span class="enterprise">
                        {{ contractData ? contractData.nome : null }}
                    </span>
                </div>
                <div class="d-flex justify-content-center">
                    <span class="unit">
                        {{ contractData ? contractData.contrato_unidade : null }}
                    </span>
                </div>
            </div>
        </div>

        <div class="">
            <hr class="horizontal dark" />
        </div>
        <sidenav-list />
    </div>
</template>

<script setup>
const segment = process.env.SEGMENT


import { computed, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";

const store = useStore();
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const contractData = computed(() => store.getters.getCurrentContract);

const navbarMinimize = () => store.commit("navbarMinimize");

const showCloseButtonLgScreen = () => {
    if (window.innerWidth > 1200) {
        return false;
    }
    return true;
}

const toggleComponent = (component) => {
    if (window.innerWidth < 1200) {
        navbarMinimize();
    }
    store.commit("updateComponent", component)
}

onBeforeUpdate(() => {
    showCloseButtonLgScreen()
});

</script>

<style>
.brasal_incorporacoes {
    width: 180px;
    height: 70;
}

.header-page {
    background-position-y: 50%;
}

.custom-bg {
    margin: 25px 25px;
    border-radius: 40px;
    color: white;
    padding: 5px 0px;
    font-size: 10px;
    white-space: nowrap;
}

.enterprise {
    font-size: 10px;
    font-weight: 800;
    padding-top: 7px;
}

.unit {
    padding-bottom: 5px;
    font-size: 10px;
}
</style>
